import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { SUPPORT_EMAIL } from '../../config';

export default function Support() {
  return (
    <LegalPageLayout title="Support">
      <p>
        Need help with your Sheba Smart Home account, app, or devices? Here's
        how to reach us.
      </p>

      <section>
        <h2 className="text-xl font-semibold text-white mt-8 mb-2">Contact us</h2>
        <p>
          Email: <a href={`mailto:${SUPPORT_EMAIL}`} className="text-[#00d4ff]">{SUPPORT_EMAIL}</a>
          <br />
          We aim to respond to all support requests within 1–2 business days.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-white mt-8 mb-2">In-app support</h2>
        <p>
          If you're signed in, the fastest way to get help with your account or
          devices is through the app itself: open <strong>Settings → Support</strong> in
          the mobile app, or <strong>Account → Support</strong> in the customer portal or
          website dashboard.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-white mt-8 mb-2">Common topics</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>I forgot my password.</strong> Use "Forgot password" on the login
            screen to reset it by email.
          </li>
          <li>
            <strong>I want to delete my account.</strong> See our{' '}
            <a href="/account-deletion" className="text-[#00d4ff]">Account Deletion</a> page.
          </li>
          <li>
            <strong>A device isn't responding.</strong> Check that your home gateway is
            online and connected to your network. If the problem persists,
            contact us with your account email and the device name.
          </li>
          <li>
            <strong>I have a question about an order.</strong> Include your order
            number when contacting us for the fastest response.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-white mt-8 mb-2">Security issues</h2>
        <p>
          If you believe you've found a security vulnerability, please email us
          directly rather than disclosing it publicly, and we'll respond as
          quickly as possible.
        </p>
      </section>
    </LegalPageLayout>
  );
}
